import React from 'react';

export const GoogleIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1096_220066)">
      <path
        d="M24.9868 12.7343C24.9868 11.71 24.9018 10.9626 24.7177 10.1875H12.749V14.8104H19.7744C19.6328 15.9593 18.868 17.6895 17.1682 18.8521L17.1444 19.0068L20.9287 21.8716L21.1908 21.8971C23.5987 19.7241 24.9868 16.5267 24.9868 12.7343Z"
        fill="#4285F4"
      />
      <path
        d="M12.7494 24.9133C16.1911 24.9133 19.0806 23.8059 21.1911 21.8959L17.1686 18.8508C16.092 19.5844 14.6473 20.0965 12.7494 20.0965C9.37828 20.0965 6.51716 17.9235 5.49724 14.9199L5.34775 14.9323L1.41279 17.9082L1.36133 18.048C3.4576 22.1173 7.76352 24.9133 12.7494 24.9133Z"
        fill="#34A853"
      />
      <path
        d="M5.4966 14.9209C5.22749 14.1459 5.07174 13.3153 5.07174 12.4572C5.07174 11.599 5.22749 10.7685 5.48245 9.99345L5.47531 9.82836L1.49105 6.80469L1.3607 6.86529C0.496726 8.55393 0.000976562 10.4502 0.000976562 12.4572C0.000976562 14.4642 0.496726 16.3603 1.3607 18.049L5.4966 14.9209Z"
        fill="#FBBC05"
      />
      <path
        d="M12.7494 4.8167C15.143 4.8167 16.7577 5.8271 17.6784 6.67146L21.2761 3.23884C19.0665 1.23187 16.1911 0 12.7494 0C7.76351 0 3.4576 2.79589 1.36133 6.86517L5.48308 9.9933C6.51715 6.98979 9.37828 4.8167 12.7494 4.8167Z"
        fill="#EB4335"
      />
    </g>
    <defs>
      <clipPath id="clip0_1096_220066">
        <rect width="25" height="25" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MetamaskIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.3311 0.75L12.0342 7.62908L13.763 3.57505L21.3311 0.75Z"
      fill="#E17726"
    />
    <path
      d="M0.690684 0.757812L8.23855 3.57524L9.88014 7.68243L0.690684 0.757812ZM17.5898 15.3796L21.6989 15.4578L20.2628 20.3364L15.2487 18.9559L17.5898 15.3796ZM4.41024 15.3796L6.74254 18.9559L1.73695 20.3364L0.30957 15.4578L4.41024 15.3796Z"
      fill="#E27625"
    />
    <path
      d="M9.65775 6.63669L9.82567 12.0604L4.80078 11.8318L6.2301 9.67544L6.24822 9.6547L9.65775 6.63669ZM12.2919 6.57617L15.7535 9.65487L15.7714 9.67552L17.2007 11.8319L12.1769 12.0604L12.2919 6.57617ZM6.89051 15.3958L9.63423 17.5336L6.44702 19.0723L6.89051 15.3958ZM15.1117 15.3954L15.5459 19.0724L12.3676 17.5334L15.1117 15.3954Z"
      fill="#E27625"
    />
    <path
      d="M12.437 17.332L15.6622 18.8937L12.6621 20.3195L12.6933 19.3772L12.437 17.332ZM9.56218 17.3327L9.31597 19.3618L9.3362 20.3184L6.3291 18.8937L9.56218 17.3327Z"
      fill="#D5BFB2"
    />
    <path
      d="M8.63109 12.7676L9.47389 14.5388L6.60449 13.6982L8.63109 12.7676ZM13.3694 12.7677L15.4056 13.6982L12.5268 14.5386L13.3694 12.7677Z"
      fill="#233447"
    />
    <path
      d="M7.10898 15.3767L6.64518 19.1887L4.15918 15.4601L7.10898 15.3767ZM14.8912 15.3768L17.8411 15.4601L15.3458 19.1888L14.8912 15.3768ZM17.2725 11.6152L15.1257 13.8031L13.4705 13.0468L12.6781 14.7127L12.1586 11.8479L17.2725 11.6152ZM4.72641 11.6152L9.84135 11.8479L9.32177 14.7127L8.52916 13.047L6.88275 13.8032L4.72641 11.6152Z"
      fill="#CC6228"
    />
    <path
      d="M4.58203 11.1665L7.0109 13.6312L7.09503 16.0644L4.58203 11.1665ZM17.421 11.1621L14.9034 16.0687L14.9982 13.6312L17.421 11.1621ZM9.72287 11.3167L9.82062 11.932L10.0622 13.4648L9.90687 18.1726L9.17266 14.3907L9.1724 14.3516L9.72287 11.3167ZM12.2764 11.3081L12.8283 14.3516L12.8281 14.3907L12.092 18.1821L12.0629 17.2338L11.948 13.4369L12.2764 11.3081Z"
      fill="#E27525"
    />
    <path
      d="M15.2137 13.5332L15.1315 15.6472L12.5693 17.6435L12.0513 17.2776L12.6319 14.287L15.2137 13.5332ZM6.79492 13.5332L9.36775 14.287L9.94835 17.2776L9.43038 17.6435L6.86805 15.6471L6.79492 13.5332Z"
      fill="#F5841F"
    />
    <path
      d="M5.83887 18.4277L9.11697 19.981L9.10309 19.3177L9.37739 19.0769H12.6218L12.906 19.3168L12.885 19.9796L16.1424 18.4316L14.5573 19.7414L12.6408 21.0578H9.35107L7.43577 19.736L5.83887 18.4277Z"
      fill="#C0AC9D"
    />
    <path
      d="M12.203 17.125L12.6665 17.4525L12.9381 19.6195L12.545 19.2876H9.45786L9.07227 19.6261L9.33497 17.4526L9.79861 17.125H12.203Z"
      fill="#161616"
    />
    <path
      d="M20.7177 0.941406L21.8337 4.28933L21.1367 7.67449L21.633 8.0573L20.9614 8.56968L21.4662 8.95951L20.7978 9.56812L21.2081 9.86528L20.1192 11.137L15.653 9.83659L15.6143 9.81585L12.3959 7.10092L20.7177 0.941406ZM1.28299 0.941406L9.60486 7.10092L6.38634 9.81585L6.34766 9.83659L1.88145 11.137L0.792533 9.86528L1.20251 9.56838L0.534564 8.95951L1.03831 8.5701L0.35666 8.05628L0.871667 7.67322L0.166992 4.2895L1.28299 0.941406Z"
      fill="#763E1A"
    />
    <path
      d="M15.4342 9.55152L20.1664 10.9293L21.7038 15.6677H17.6478L14.8531 15.7029L16.8855 11.7413L15.4342 9.55152ZM6.56576 9.55152L5.11418 11.7413L7.14687 15.7029L4.35348 15.6677H0.304688L1.83346 10.9294L6.56576 9.55152ZM13.9947 3.55273L12.6711 7.12765L12.3902 11.9569L12.2827 13.4707L12.2742 17.3375H9.72571L9.71742 13.4779L9.60959 11.9557L9.3286 7.12765L8.00516 3.55273H13.9947Z"
      fill="#F5841F"
    />
  </svg>
);

export const DiscordIcon = () => (
  <svg
    width="24"
    height="19"
    viewBox="0 0 24 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.3175 1.49295C18.7875 0.80295 17.1475 0.29295 15.4325 0.00295017C15.4172 1.80819e-05 15.4014 0.00190762 15.3872 0.0083575C15.3731 0.0148074 15.3613 0.0254985 15.3535 0.0389502C15.1435 0.40795 14.9095 0.88895 14.7455 1.26895C12.9266 0.997187 11.0774 0.997187 9.25848 1.26895C9.07582 0.847811 8.86983 0.437174 8.64148 0.0389502C8.63374 0.0253329 8.62203 0.0143999 8.60792 0.0076103C8.5938 0.000820665 8.57795 -0.00150281 8.56248 0.000950073C6.84848 0.29095 5.20848 0.80095 3.67748 1.49195C3.66431 1.49747 3.65314 1.5069 3.64548 1.51895C0.533481 6.09395 -0.319519 10.556 0.0994806 14.962C0.100647 14.9727 0.103996 14.9832 0.109326 14.9926C0.114655 15.0021 0.121853 15.0104 0.130481 15.017C1.94687 16.3394 3.97282 17.3468 6.12348 17.997C6.13847 18.0016 6.15451 18.0016 6.16949 17.9969C6.18448 17.9923 6.19772 17.9832 6.20748 17.9709C6.67028 17.352 7.08038 16.6954 7.43348 16.0079C7.43838 15.9986 7.44121 15.9882 7.44176 15.9776C7.44232 15.967 7.4406 15.9565 7.43671 15.9466C7.43282 15.9367 7.42686 15.9278 7.41923 15.9205C7.4116 15.9131 7.40248 15.9075 7.39248 15.9039C6.74649 15.6607 6.12057 15.3671 5.52048 15.0259C5.5097 15.0198 5.50061 15.0111 5.49404 15.0005C5.48746 14.99 5.48361 14.978 5.48281 14.9656C5.48202 14.9532 5.48432 14.9408 5.48949 14.9295C5.49467 14.9183 5.50257 14.9084 5.51248 14.9009C5.63848 14.8079 5.76448 14.711 5.88448 14.614C5.89528 14.6052 5.90829 14.5997 5.92206 14.5979C5.93584 14.5961 5.94983 14.5982 5.96248 14.604C9.88948 16.368 14.1425 16.368 18.0235 14.604C18.0362 14.5979 18.0503 14.5955 18.0643 14.5971C18.0782 14.5987 18.0915 14.6042 18.1025 14.6129C18.2225 14.7109 18.3475 14.8079 18.4745 14.9009C18.4845 14.9083 18.4925 14.918 18.4979 14.9292C18.5032 14.9403 18.5057 14.9527 18.5051 14.9651C18.5045 14.9774 18.5008 14.9895 18.4945 15.0001C18.4881 15.0107 18.4791 15.0196 18.4685 15.0259C17.8705 15.3699 17.2485 15.661 16.5955 15.903C16.5855 15.9066 16.5763 15.9123 16.5687 15.9198C16.561 15.9272 16.5551 15.9362 16.5512 15.9462C16.5473 15.9561 16.5456 15.9668 16.5462 15.9774C16.5467 15.9881 16.5496 15.9985 16.5545 16.0079C16.9145 16.695 17.3265 17.3489 17.7795 17.9699C17.7889 17.9827 17.802 17.9922 17.8171 17.9972C17.8321 18.0022 17.8483 18.0025 17.8635 17.9979C20.0178 17.3496 22.0471 16.3417 23.8655 15.017C23.8744 15.0107 23.8818 15.0027 23.8873 14.9934C23.8928 14.9841 23.8963 14.9737 23.8975 14.9629C24.3975 9.86895 23.0595 5.44295 20.3485 1.52095C20.3418 1.5082 20.3308 1.49827 20.3175 1.49295ZM8.02048 12.2789C6.83848 12.2789 5.86348 11.2099 5.86348 9.89895C5.86348 8.58695 6.81948 7.51895 8.02048 7.51895C9.23048 7.51895 10.1965 8.59595 10.1775 9.89895C10.1775 11.2109 9.22148 12.2789 8.02048 12.2789ZM15.9955 12.2789C14.8125 12.2789 13.8385 11.2099 13.8385 9.89895C13.8385 8.58695 14.7935 7.51895 15.9955 7.51895C17.2055 7.51895 18.1715 8.59595 18.1525 9.89895C18.1525 11.2109 17.2065 12.2789 15.9955 12.2789Z"
      fill="#EFEFF0"
    />
  </svg>
);

export const TwitterIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.0773 4.49798C22.2626 4.86804 21.3874 5.11808 20.4674 5.2311C21.4167 4.6488 22.1269 3.73232 22.4656 2.65268C21.5736 3.19576 20.5975 3.57803 19.5795 3.78286C18.8949 3.03361 17.9882 2.53699 17.0001 2.37011C16.012 2.20323 14.9978 2.37543 14.1149 2.85997C13.2321 3.34451 12.53 4.11428 12.1176 5.04978C11.7053 5.98527 11.6058 7.03414 11.8345 8.03356C10.0272 7.94054 8.25926 7.45901 6.64528 6.62023C5.0313 5.78145 3.60741 4.60416 2.46602 3.16476C2.07574 3.85488 1.85134 4.65501 1.85134 5.50715C1.8509 6.27427 2.03519 7.02964 2.38784 7.70624C2.7405 8.38284 3.25062 8.95975 3.87295 9.38578C3.15121 9.36224 2.4454 9.16233 1.81426 8.80268V8.86269C1.81419 9.93861 2.17725 10.9814 2.84183 11.8142C3.50642 12.6469 4.4316 13.2183 5.46039 13.4314C4.79086 13.6172 4.08891 13.6445 3.40755 13.5115C3.69781 14.4372 4.26322 15.2468 5.02461 15.8268C5.78601 16.4068 6.70528 16.7282 7.65372 16.746C6.04368 18.0416 4.05529 18.7444 2.00842 18.7413C1.64584 18.7414 1.28356 18.7197 0.923462 18.6763C3.00115 20.0457 5.41974 20.7725 7.88983 20.7696C16.2514 20.7696 20.8225 13.6705 20.8225 7.51347C20.8225 7.31344 20.8176 7.11141 20.8088 6.91137C21.698 6.25224 22.4655 5.43603 23.0754 4.50098L23.0773 4.49798Z"
      fill="white"
    />
  </svg>
);

export const SteamIcon = ({ fill = '#171D25' }: { fill?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3728_17944)">
      <circle cx={12.333} cy={11.52} r={12} fill={fill} />
      <path
        d="M12.333 -0.47998C13.9089 -0.47998 15.4693 -0.169591 16.9252 0.433465C18.3811 1.03652 19.704 1.92044 20.8183 3.03474C21.9326 4.14904 22.8165 5.47191 23.4196 6.92782C24.0226 8.38372 24.333 9.94416 24.333 11.52C24.333 14.7026 23.0687 17.7549 20.8183 20.0053C18.5679 22.2557 15.5156 23.52 12.333 23.52C6.81301 23.52 2.19301 19.824 0.765008 14.796L5.36101 16.692C5.51912 17.4604 5.9372 18.1508 6.54483 18.647C7.15247 19.1431 7.91253 19.4147 8.69701 19.416C10.569 19.416 12.093 17.892 12.093 16.02V15.864L16.173 12.948H16.269C18.765 12.948 20.793 10.92 20.793 8.42402C20.793 5.92802 18.765 3.90002 16.269 3.90002C13.773 3.90002 11.733 5.92802 11.733 8.42402V8.48402L8.88901 12.636L8.69701 12.624C7.98901 12.624 7.32901 12.84 6.78901 13.212L0.333008 10.56C0.849008 4.38002 6.00901 -0.47998 12.333 -0.47998ZM7.86901 17.724C8.82901 18.12 9.93301 17.676 10.329 16.716C10.725 15.756 10.269 14.664 9.33301 14.268L7.79701 13.632C8.38501 13.416 9.04501 13.404 9.66901 13.668C10.305 13.92 10.797 14.412 11.049 15.048C11.313 15.672 11.313 16.368 11.049 16.992C10.533 18.288 9.00901 18.912 7.71301 18.372C7.11301 18.12 6.65701 17.664 6.40501 17.124L7.86901 17.724ZM19.293 8.42402C19.293 10.092 17.937 11.448 16.269 11.448C15.4691 11.4448 14.703 11.1248 14.1385 10.5581C13.574 9.99131 13.257 9.22396 13.257 8.42402C13.2554 8.02803 13.3322 7.63565 13.483 7.2695C13.6339 6.90335 13.8557 6.57068 14.1357 6.29067C14.4157 6.01067 14.7483 5.78887 15.1145 5.63806C15.4806 5.48726 15.873 5.41043 16.269 5.41202C17.0689 5.41201 17.8363 5.72896 18.4031 6.29348C18.9698 6.858 19.2898 7.62409 19.293 8.42402ZM14.013 8.42402C14.013 9.67202 15.021 10.692 16.281 10.692C17.529 10.692 18.537 9.67202 18.537 8.42402C18.537 7.17602 17.529 6.15602 16.281 6.15602C15.021 6.15602 14.013 7.17602 14.013 8.42402Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3728_17944">
        <rect x={0.333008} width={24} height={24} rx={12} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const XIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.99 2H21.298L14.071 10.26L22.573 21.5H15.915L10.701 14.683L4.735 21.5H1.425L9.155 12.665L1 2H7.825L12.538 8.231L17.988 2H17.99ZM16.829 19.52H18.662L6.83 3.876H4.863L16.829 19.52Z"
        fill="white"
      />
    </svg>
  );
};
